import { useContext }                                            from "react";
import Link                                                      from "next/link";
import { Trophy, ChevronRight, Crown }                           from "lucide-react";
import Context                                                   from "@/provider/Context";
import CrewCard                                                  from "@/components/CrewCard";
import HeroSection                                               from "@/components/HeroSection";
import PlayerCard                                                from "@/components/PlayerCard";
import ReiCard                                                   from "@/components/ReiCard";
import Footer                                                    from "@/components/common/Footer";
import { get_five_members_top_rankings }                         from "@/utils/MemberFunction";
import { get_three_crew_top_rankings, get_maior_xp_crew }        from "@/utils/CrewFunction";

const Vazio = ({ carregado, texto }) => (
  <div className="void-card p-6 text-center text-muted-foreground font-rajdhani">
    {carregado ? texto : "Carregando..."}
  </div>
);

export default function Page() {
  const { Crews, Jogadores, Reis, Carregado }                     = useContext(Context);
  const five_top_rankings_users                                   = get_five_members_top_rankings(Jogadores);
  const three_top_rankings_crews                                  = get_three_crew_top_rankings(Crews);
  const maior_xp_crew                                             = get_maior_xp_crew(Crews);

  return (
    <div className="min-h-screen">
      <HeroSection />

      {/* Reis */}
      <section className="py-16 relative">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="font-orbitron text-3xl md:text-4xl font-bold text-neon mb-3 flex items-center justify-center gap-3">
              <Crown className="w-8 h-8 text-cosmic-gold" />
              OS REIS
            </h2>
            <p className="text-muted-foreground font-rajdhani max-w-2xl mx-auto">
              Cada Rei é um cargo de quem tem mais em uma atividade. Supere o dono atual e o título é seu.
            </p>
          </div>

          {Reis.length ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {Reis.map((rei, idx) => <ReiCard key={rei?.chave || rei?.nome || idx} rei={rei} />)}
            </div>
          ) : (
            <Vazio carregado={Carregado} texto="Os Reis ainda não foram definidos." />
          )}
        </div>
      </section>

      {/* Top Players & Crews */}
      <section className="py-16 relative">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Top Players */}
            <div className="min-w-0">
              <div className="flex items-center justify-between mb-6">
                <h2 className="font-orbitron text-2xl font-bold flex items-center gap-3">
                  <Trophy className="w-6 h-6 text-cosmic-gold" />
                  Top 5 por Nível
                </h2>
                <Link
                  href="/rankings"
                  className="text-sm text-primary hover:underline flex items-center gap-1"
                >
                  Ver todos <ChevronRight className="w-4 h-4" />
                </Link>
              </div>

              <div className="space-y-3">
                {five_top_rankings_users.map((jogador, idx) => (
                  <PlayerCard key={jogador?.discordId || jogador?.slug || idx} jogador={jogador} />
                ))}
                {!five_top_rankings_users.length && <Vazio carregado={Carregado} texto="Nenhum jogador no ranking ainda." />}
              </div>
            </div>

            {/* Top Crews */}
            <div className="min-w-0">
              <div className="flex items-center justify-between mb-6">
                <h2 className="font-orbitron text-2xl font-bold flex items-center gap-3">
                  <Trophy className="w-6 h-6 text-primary" />
                  Top Crews
                </h2>
                <Link
                  href="/crews"
                  className="text-sm text-primary hover:underline flex items-center gap-1"
                >
                  Ver todas <ChevronRight className="w-4 h-4" />
                </Link>
              </div>

              <div className="space-y-4">
                { three_top_rankings_crews.map((crew, idx) => ( <CrewCard key={crew.slug || crew.nome || idx} crew={crew} maiorXp={maior_xp_crew} />)) }
                {!three_top_rankings_crews.length && <Vazio carregado={Carregado} texto="Nenhuma crew cadastrada ainda." />}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
